import { useEffect, useState } from 'react';
import { supabase } from '../services/supabase';
import { useAuth } from '../context/AuthContext';

export interface Profile {
  id: string;
  email: string;
  full_name: string;
  avatar_url: string;
  title: string | null;
  bio: string | null;
  role: 'allocator' | 'manager' | 'service_provider' | 'candidate';
  account_status: 'pending_review' | 'approved' | 'rejected' | 'suspended';
  is_super_admin: boolean;
  submitted_at: string | null;
  reviewed_at: string | null;
  rejection_reason: string | null;
  admin_notes: string | null;
}

export interface Firm {
  id: string;
  name: string;
  logo_url: string;
  description: string;
  type: string;
  headquarters: string;
  aum_min: number;
  aum_max: number;
  aum_exact: number;
  website: string;
}

export function useProfile() {
  const { user } = useAuth();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [firm, setFirm] = useState<Firm | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    async function fetchProfile() {
      setLoading(true);

      const { data: profileData } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user!.id)
        .single();

      if (profileData) {
        setProfile(profileData);
      }

      const { data: firmData } = await supabase
        .from('firms')
        .select('*')
        .eq('owner_id', user!.id)
        .single();

      if (firmData) {
        setFirm(firmData);
      }

      setLoading(false);
    }

    fetchProfile();
  }, [user]);

  return { profile, firm, loading };
}